// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__36YcU","content":"GlobalSearch_content__2CpXX"};